import * as $ from 'jquery';
import GeoFilterController from './GeoFilterController';

export default class MapsController {
  /**
   * @author Markus Hölzle <m.hoelzle@andersundsehr.com>
   * @param $mapContainer
   * param $settings
   */
  constructor($mapContainer, settings) {
    this.mapContainer = $mapContainer;
    this.googleMap = null;
    this.geoFilter = null;
    this.markerCluster = null;
    this.markers = {};
    this.infoWindows = {};
    this.lastMaxResLength = 0;
    this.lastMaxZoom = 0;

    this.settings = {
      map: {
        default: {
          zoom: 6,
          lat: 51.1641175,
          lng: 10.4541194,
        },
        styles: [
          {featureType: 'administrative', elementType: 'labels.text.fill', stylers: [{color: '#0c0b0b'}]}, // eslint-disable-line object-curly-spacing
          {featureType: 'landscape', elementType: 'all', stylers: [{color: '#d8dadc'}]}, // eslint-disable-line object-curly-spacing
          {featureType: 'poi', elementType: 'all', stylers: [{visibility: 'off'}]}, // eslint-disable-line object-curly-spacing
          {featureType: 'road', elementType: 'all', stylers: [{saturation: -100}, {lightness: 45}]}, // eslint-disable-line object-curly-spacing
          {featureType: 'road', elementType: 'labels.text.fill', stylers: [{color: '#090909'}]}, // eslint-disable-line object-curly-spacing
          {featureType: 'road.highway', elementType: 'all', stylers: [{visibility: 'simplified'}]}, // eslint-disable-line object-curly-spacing
          {featureType: 'road.arterial', elementType: 'labels.icon', stylers: [{visibility: 'off'}]}, // eslint-disable-line object-curly-spacing
          {featureType: 'transit', elementType: 'all', stylers: [{visibility: 'off'}]}, // eslint-disable-line object-curly-spacing
          {featureType: 'water', elementType: 'all', stylers: [{color: '#d4e4eb'}, {visibility: 'on'}]}, // eslint-disable-line object-curly-spacing
          {featureType: 'water', elementType: 'geometry.fill', stylers: [{visibility: 'on'}, {color: '#1d2a30'}]}, // eslint-disable-line object-curly-spacing
          {featureType: 'water', elementType: 'labels.text.fill', stylers: [{color: '#9b7f7f'}]}, // eslint-disable-line object-curly-spacing
          {featureType: 'water', elementType: 'labels.text.stroke', stylers: [{color: '#fef7f7'}]}, // eslint-disable-line object-curly-spacing
        ],
        placeMarkerIcon: '/_assets/0f050d05b5fe77de8c68787932c58478/Images/PlaceMarkerNew.png',
      },
      cluster: {
        gridSize: 50,
        zoomOnClick: true,
        averageCenter: true,
        styles: [
          {
            url: '/_assets/0f050d05b5fe77de8c68787932c58478/Images/PlaceMarkerNew_redcircle.svg',
            height: 30,
            width: 30,
            textColor: '#ffffff',
            textSize: 14,
            anchor: [0, 0],
            textAlign: 'center',
          },
          {
            url: '/_assets/0f050d05b5fe77de8c68787932c58478/Images/PlaceMarkerNew_redcircle.svg',
            height: 40,
            width: 40,
            textColor: '#ffffff',
            textSize: 14,
            anchor: [0, 0],
            textAlign: 'center',
          },
          {
            url: '/_assets/0f050d05b5fe77de8c68787932c58478/Images/PlaceMarkerNew_redcircle.svg',
            height: 50,
            width: 50,
            textColor: '#ffffff',
            textSize: 14,
            anchor: [0, 0],
            textAlign: 'center',
          },
        ],
      },
      boundsChangedTimeout: 400,
      placeMarkerMinimum: 3,
    };
    if (typeof settings !== 'undefined') {
      $.extend(this.settings, settings);
    }

    $('.js-fc-map-consent-accept').on('click', function (e) {
      usercentrics.updateConsents([{'templateId': 'S1pcEj_jZX', 'status': true}]);
      location.reload();
    });

    var consent = usercentrics.getConsents("S1pcEj_jZX").consentStatus; // Google Maps Consent ID

    if (consent) {
      $('#js-fc-map-consent').hide();
      $('#js-fc-map').show();

      // initMap
      this.initMap();
    } else {
      $('#js-fc-map').hide();
      $('#js-fc-map-consent').show();
    }
  }

  /**
   * Display the google map
   */
  initMap() {
    var self = this;
    var $filterForm = $('form.js-filter-form');
    var center = $filterForm.find('.js-partner-center').val();
    var mapZoom = parseInt($filterForm.find('.js-partner-mapZoom').val(), 10);
    // use plain js because $(document).width() does not calc scrollbars.
    // We need it for our mobile layout, so trigger it if viewport is smaller than 768px. Doesn't necessarily have to be a touch device
    // On init should be enough for now
    var isMovable = document.body.parentNode.clientWidth > 768;
    var mapOptions = {
      zoom: (mapZoom !== 0) ? mapZoom : self.settings.map.default.zoom,
      center: new google.maps.LatLng(self.settings.map.default.lat, self.settings.map.default.lng),
      minZoom: 2,
      disableDefaultUI: true,
      scrollwheel: isMovable,
      draggable: isMovable,
      zoomControl: true,
      styles: self.settings.map.styles,
    };
    self.googleMap = new google.maps.Map(self.mapContainer[0], mapOptions);
    self.markerCluster = new MarkerClusterer(self.googleMap, [], self.settings.cluster);
    self.googleMap.setOptions({
      styles: self.settings.map.styles,
    });

    // set position if given
    if (center) {
      center = center.split(',');
      self.googleMap.setCenter({
        lat: parseFloat(center[0]),
        lng: parseFloat(center[1]),
      });
    }

    var boundChangedCounter = 0;
    var timeout;
    self.googleMap.addListener('idle', () => {
      boundChangedCounter++;
      var localCounter = boundChangedCounter;
      window.clearTimeout(timeout);
      timeout = window.setTimeout(() => {
        if (localCounter === boundChangedCounter) {
          $filterForm.trigger('submit');
        }
      }, self.settings.boundsChangedTimeout);
    });

    self.geoFilter = new GeoFilterController($('.js-geo-filter'), self.googleMap, {});
    self.geoFilter.toggleFormFields();
  }

  /**
   * @param {jQuery} $filterForm
   */
  beforeSetHashFromFilterForm($filterForm) {
    var bounds = this.googleMap.getBounds().toJSON();
    google.maps.event.trigger(this.googleMap, 'resize');

    $filterForm.find('.js-partner-map-south').val(bounds.south);
    $filterForm.find('.js-partner-map-west').val(bounds.west);
    $filterForm.find('.js-partner-map-north').val(bounds.north);
    $filterForm.find('.js-partner-map-east').val(bounds.east);
    $filterForm.find('.js-partner-center').val(this.googleMap.getCenter().toUrlValue());
    $filterForm.find('.js-partner-mapZoom').val(this.googleMap.getZoom());
    return $filterForm;
  }

  /**
   * @param {jQuery} $filterForm
   */
  afterSetFilterFormFromHash($filterForm) {
    $('.js-geo-filter-country-clone').val($filterForm.find('.js-geo-filter-country').val());
    $('.js-partner-productGroup-clone').val($filterForm.find('.js-partner-productGroup').val());
    $('.js-partner-productGroupCategory-clone').val($filterForm.find('.js-partner-productGroupCategory').val());
    $('.js-geo-filter-city-clone').val($filterForm.find('.js-geo-filter-city').val());
  }

  /**
   * @param responseData
   * @returns {*}
   */
  validateShowResults(responseData) {
    var localResponseData = responseData;
    if (this.geoFilter.isMayZoomOut()) {
      var lis = $(localResponseData).children('li');

      if (lis.length < this.settings.placeMarkerMinimum && $('.js-geo-filter-city').val() !== '') {
        if (lis.length !== this.lastMaxResLength) {
          // set lastMaxResLength and lastMaxZoom
          this.lastMaxResLength = lis.length;
          this.lastMaxZoom = this.googleMap.getZoom();
        }
        this.googleMap.setZoom(this.googleMap.getZoom() - 1);
        localResponseData = '';
      } else {
        this.geoFilter.setMayZoomOut(false);
      }
    }

    if (this.googleMap.getZoom() === 2 &&
      localResponseData.length === 0 &&
      this.lastMaxResLength &&
      this.lastMaxResLength < this.settings.placeMarkerMinimum &&
      this.lastMaxZoom) {
      this.googleMap.setZoom(this.lastMaxZoom);
      this.geoFilter.setMayZoomOut(false);
    }

    return localResponseData;
  }

  /**
   * @param {string} responseData
   * @returns {string}
   */
  beforeShowResults(responseData) {
    var self = this;
    var lis = $(responseData).children('li');
    var bounds = new google.maps.LatLngBounds();
    self.clearMap();
    lis.each((index, elem) => {
      var $item = $(elem);
      var uid = parseInt($item.attr('data-uid'), 10);
      self.infoWindows[uid] = new google.maps.InfoWindow({
        content: $item.html(),
      });
      self.markers[uid] = new google.maps.Marker({
        position: {
          lat: parseFloat($item.attr('data-lat')),
          lng: parseFloat($item.attr('data-lng')),
        },
        icon: self.settings.map.placeMarkerIcon,
        title: $item.find('.js-partner-title').text() + ' ' + $item.find('.js-partner-title2').text(),
      });
      self.markerCluster.addMarker(self.markers[uid]);
      bounds.extend(self.markers[uid].getPosition());
      self.markers[uid].addListener('click', self.showMarker.bind(self, uid));
    });

    var $filterForm = $('form.js-filter-form');
    if (lis.length > 0 && $filterForm.hasClass('changedFilters')) {
      $filterForm.removeClass('changedFilters');
      self.googleMap.fitBounds(bounds);
      if (self.googleMap.getZoom() > 6) {
        self.googleMap.setZoom(5);
      }
    }
    self.markerCluster.repaint();
    return responseData;
  }

  /**
   * @param responseData
   * @param {jQuery} $ajaxTarget
   */
  afterShowResults(responseData, $ajaxTarget) {
    // "pagination"
    var self = this;
    var showElementsStep = 5;
    var $liElements = $ajaxTarget.find('.js-partner-results > li');
    var $paginationLink = $ajaxTarget.find('.js-partner-show-more');
    $liElements.hide().slice(0, showElementsStep).show();
    if ($liElements.length <= showElementsStep) {
      $paginationLink.hide();
    }
    $paginationLink.unbind('click').click((event) => {
      var visibleElements = $liElements.filter(':visible').length;
      $liElements.slice(visibleElements, visibleElements + showElementsStep).show();
      if ($liElements.filter(':hidden').length === 0) {
        $(event.target).hide();
      }
    });

    $liElements.each((index, elem) => {
      var $item = $(elem);
      var markerUid = $item.data('uid');
      $item.hover(() => {
        self.showBounceEffect(self.markers[markerUid]);
      }, () => {
        self.hideBounceEffect(self.markers[markerUid]);
      });

      $item.find('.js-show-partner-business-unit').click((event) => {
        $item.find('.js-partner-business-unit').slideToggle();
        $(event.target).toggleClass('partner__businessUnitToggle--open');
      });
      $item.find('.js-show-partner-product-groups').click((event) => {
        $item.find('.js-partner-product-groups').slideToggle();
        $(event.target).toggleClass('partner__productGroupsToggle--open');
      });
    });
  }

  /**
   * @return {void}
   */
  clearMap() {
    var self = this;

    for (var uid in self.markers) {
      if ({}.hasOwnProperty.call(self.markers, uid)) {
        self.markerCluster.removeMarker(self.markers[uid], true);
      }
    }
    self.markers = {};
    self.infoWindows = {};
  }

  /**
   * @param {number} uid
   */
  showMarker(uid) {
    var self = this;
    for (var localUid in self.infoWindows) {
      if ({}.hasOwnProperty.call(self.infoWindows, localUid)) {
        self.infoWindows[localUid].close();
      }
    }
    self.infoWindows[uid].open(self.googleMap, self.markers[uid]);
  }

  /**
   * @param {google.maps.Marker} marker
   */
  showBounceEffect(marker) {
    /* eslint-disable no-underscore-dangle */
    var currentMarkersCluster = null;
    for (var i = 0; i < this.markerCluster.clusters_.length; i++) {
      if (this.markerCluster.clusters_[i].isMarkerAlreadyAdded(marker)) {
        currentMarkersCluster = this.markerCluster.clusters_[i];
      }
    }
    if (currentMarkersCluster === null || currentMarkersCluster.clusterIcon_.visible_ === false) {
      marker.setAnimation(google.maps.Animation.BOUNCE);
    } else {
      $(currentMarkersCluster.clusterIcon_.div_).addClass('bounce-animation');
    }
    /* eslint-enable no-underscore-dangle */
  }

  /**
   * @param {google.maps.Marker} marker
   */
  hideBounceEffect(marker) {
    /* eslint-disable no-underscore-dangle */
    var currentMarkersCluster = null;
    for (var i = 0; i < this.markerCluster.clusters_.length; i++) {
      if (this.markerCluster.clusters_[i].isMarkerAlreadyAdded(marker)) {
        currentMarkersCluster = this.markerCluster.clusters_[i];
      }
    }
    if (currentMarkersCluster !== null) {
      $(currentMarkersCluster.clusterIcon_.div_).removeClass('bounce-animation');
    }
    marker.setAnimation(null);
    /* eslint-enable no-underscore-dangle */
  }
};
